import React, { useState } from 'react';
import { EditableField } from 'modules/cm/fields/EditableField';
import fields, { FIELDS, INPUTS } from 'modules/cm/fields/types';
import { VARIANTS_TYPES } from 'modules/af_cm_ui_kit/components/TextField/variants.types';
import { FormModel, Props } from './Rationale.types';
import { useDispatch } from 'react-redux';
import validationSchema from './validationSchema';
import styles from './Rationale.module.scss';
import useCaseIsReadOnly from 'helpers/hooks/useCaseIsReadOnly/useCaseIsReadOnly';
import { FormProvider, useForm } from 'react-hook-form';
import useYupValidationResolver from 'form/yup/reactHookFormResolver';
import CheckDirty from 'modules/cm/components/CheckDirty/CheckDirty';
import { SUBPAGES } from 'modules/cm/store/subPages/types';
import * as subPages from '../../../../store/subPages';
import { updateRationale } from 'modules/cm/store/cases/update/actions';

const UpdateableField = ({ isUpdateable = true, isCaseReadOnly, isReadOnly, ...props }: any) => {
  return <EditableField {...props} readOnly={!isUpdateable} disabled={isCaseReadOnly || isReadOnly} />;
};

const Rationale: React.FC<Props> = ({ data, isEditable, isReadOnly }) => {
  const defaultString =
    'A. Loan\nB. Borrower\nC. Credit Record\nD. Mortgaged Property\nH. Affordability\nI. Other Comments';
  const initialValues = { [FIELDS.RATIONALE]: data || defaultString };
  const dispatch = useDispatch();
  const isCaseReadOnly = useCaseIsReadOnly();
  const [expanded, setExpanded] = useState<boolean>(false);

  const methods = useForm<FormModel>({
    mode: 'onBlur',
    defaultValues: initialValues,
    resolver: useYupValidationResolver(validationSchema),
  });

  const handleFieldBlur = () => {
    dispatch(updateRationale(methods.getValues().rationale));
  };

  return (
    <FormProvider<FormModel> {...methods}>
      <CheckDirty
        initialData={methods.getValues()}
        onDirtyChange={(isDirty) => {
          dispatch(subPages.actions.updateSubPageIsDirty(SUBPAGES.RATIONALE, isDirty));
        }}
      />
      <form onSubmit={() => {}}>
        <div className={styles.box}>
          <div className={styles.titleAndButton}>
            <h3>Rationale</h3>
            <button type="button" onClick={() => setExpanded(!expanded)}>
              <svg
                className={expanded ? styles.arrowUp : styles.arrowDown}
                width="8"
                height="12"
                viewBox="0 0 8 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path d="M7.41 10.58L2.83 6L7.41 1.41L6 0L0 6L6 12L7.41 10.58Z" fill="#3A4451" />
              </svg>
            </button>
          </div>
          <div className={styles.textBox}>
            {expanded ? (
              <UpdateableField
                onBlur={handleFieldBlur}
                fieldType={INPUTS.TEXTAREA}
                field={fields[FIELDS.RATIONALE]}
                variant={VARIANTS_TYPES.TEXT}
                isUpdateable={isEditable}
                isCaseReadOnly={isCaseReadOnly}
                isReadOnly={isReadOnly}
              />
            ) : null}
          </div>
        </div>
      </form>
    </FormProvider>
  );
};

export default Rationale;
